import { component, inject } from 'tsdi';
import { wrapRequest } from 'wrap-request';

import { Api } from '../core/api';
import { ConnectApiEmailVerificationDto } from '../core/api/dtos';
import { UrlStore } from '../core/url-store';

export type EmailVerificationAction = 'APPROVE' | 'REJECT';

@component
export class EmailVerificationStore {
    @inject
    private api!: Api;

    @inject
    private url!: UrlStore;

    public emailVerification = wrapRequest<ConnectApiEmailVerificationDto>(
        (params: { uuid: string; action: EmailVerificationAction }) => {
            const controller =
                this.api.client.ConnectApiEmailVerificationController;
            return params.action === 'APPROVE'
                ? controller.approveEmail(params.uuid)
                : controller.rejectEmail(params.uuid);
        }
    );

    public verify(action: EmailVerificationAction) {
        if (this.url.customerUuid) {
            void this.emailVerification.request({
                uuid: this.url.customerUuid,
                action
            });
        }
    }
}
